export default __webpack_public_path__ + "static/media/quality-popup-banner.c208ceb4.jpeg";